export const routes = Object.freeze({
  DONE: "/done",
  ADD_CARD: "/add-card",
  PAYMENT_METHODS: "/payment-methods",
  PAYMENT_PROCESS: "/payment-process",
  PAYMENT_PROCESS_SUCCESS: "/payment-process-success",
  PAYMENT_PROCESS_FAILURE: "/payment-process-failure",
  PAYMENT_PROCESS_PENDING: "/payment-process-pending",
});
